import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { getItem, GET_INFO } from 'utils/sessionStorage';
import profileAvatar from 'assets/images/icon/profile_avatar.svg';
import useAuth from 'hooks/useAuth';
import { isProfileUpdate } from 'atoms/state';
import Img from 'components/Img';
import SkeletonProfileImageContainerSmall from 'components/Suspense/Skeleton/SkeletonProfileImageContainerSmall';

const UserMenu = () => {
  const [isUpdateProfileImg, setIsUpdateProfileImg] = useRecoilState(isProfileUpdate);
  const navigate = useNavigate();
  const { disconnect } = useAuth();
  const [isMenu, setIsMenu] = useState(false);
  const { profileImg, account, admin } = getItem(GET_INFO);

  const myAccount = useMemo(() => account && `${account.substring(0, 4)}...${account.substring(account.length - 4)}`, [account]);

  useEffect(() => {
    setIsUpdateProfileImg(false);
  }, [setIsUpdateProfileImg]);

  const handleDisConnect = () => {
    navigate('/');
    disconnect();
  };

  const toggleMyMenu = () => {
    setIsMenu(!isMenu);
  };

  const goToMyPage = () => {
    navigate('/myPage');
    setIsMenu(false);
  };

  const goToAccountSetting = () => {
    navigate('/settings/account');
    setIsMenu(false);
  };

  const goToCreate = () => {
    navigate('/create');
    setIsMenu(false);
  };

  const goToMinting = () => {
    navigate('/minting');
    setIsMenu(false);
  };
  return (
    <div className="my-status row">
      <div className="my-profile inline-block relative left-12">
        <div onClick={toggleMyMenu} className={`my-profile-frame border-radius-50 overflow-hidden link hover-to-primary-border background-neutrals-6 ${isMenu && ' opened'}`}>
          <Img fallback={<SkeletonProfileImageContainerSmall />} src={profileImg || profileAvatar} alt="profile-img" className="my-profile-img object-fit-cover" width="48" height="48" />
        </div>
        {isMenu && (
          <>
            <div className="my-menu absolute padding-row-20 padding-top-24 padding-bottom-16 font-14">
              <ul className="menu-list">
                <li onClick={goToMyPage} className="font-weight-600 primary-hover link">
                  My Page
                </li>
                <li className="top-12 font-weight-600 primary-hover link">{myAccount}</li>
                <li onClick={goToAccountSetting} className="top-12 font-weight-600 primary-hover link">
                  Account Setting
                </li>
                {admin && (
                  <>
                    <li onClick={goToCreate} className="top-12 font-weight-600 primary-hover link">
                      Create
                    </li>
                    <li onClick={goToMinting} className="top-12 font-weight-600 primary-hover link">
                      Minting
                    </li>
                  </>
                 )}
                <li onClick={handleDisConnect} className="top-12 font-weight-600 primary-hover link">
                  DISCONNECT
                </li>
              </ul>
            </div>
            <div onClick={() => toggleMyMenu()} className="full-screen-invisible" />
          </>
        )}
      </div>
    </div>
  );
};

export default UserMenu;
